import { render, staticRenderFns } from "./MessageResultMediaDetails.vue?vue&type=template&id=229b153c"
import script from "./MessageResultMediaDetails.vue?vue&type=script&lang=js"
export * from "./MessageResultMediaDetails.vue?vue&type=script&lang=js"
import style0 from "./MessageResultMediaDetails.vue?vue&type=style&index=0&id=229b153c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports